<template>
  <div>
    <el-row style="height: 30px; border-bottom: 1px solid #ddd">
      <el-col :span="24"> 代采退换货单详情 </el-col>
    </el-row>
    <el-row style="height: 80px" type="flex" align="middle" justify="center">
      <el-col :span="24">
        <el-steps
          space="100%"
          :active="steps_label.index"
          finish-status="success"
          :process-status="steps_label.processStatus"
          align-center
        >
          <el-step
            v-for="(step, index) in steps_label.steps"
            :key="index"
            :title="step.title"
            :description="step.description"
          ></el-step>
        </el-steps>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-alert
          :title="`当前代采退换货单状态：${info.status_str}`"
          type="success"
          :closable="false"
        >
        </el-alert>
      </el-col>
    </el-row>
    <el-row style="border: 1px solid #ddd">
      <el-col :span="24">
        <el-row
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
        >
          <el-col :span="24"> 基本信息 </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table :data="[info]" border style="width: 100%">
              <el-table-column
                prop="receipt_sn"
                label="代采退换货单编号"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="quantity"
                label="退换货数量"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="market_name"
                label="市场/子市场"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="supply_name" label="商家" align="center">
              </el-table-column>
              <el-table-column
                prop="purchaser_gname"
                label="代采组"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="woid" label="代采订单号" align="center">
              </el-table-column>
              <el-table-column prop="status_str" label="状态" align="center">
              </el-table-column>
              <el-table-column
                prop="create_time"
                label="生成时间"
                align="center"
              >
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 单据信息等 -->
    <el-row>
      <el-col :span="24">
        <el-col>
          <div class="card-title">商品信息</div>
          <el-table :data="info.goods" border style="width: 100%">
            <el-table-column prop="goods_img" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="type_str" label="退换原因" align="center">
            </el-table-column>
            <el-table-column prop="quantity" label="数量" align="center">
            </el-table-column>
            <el-table-column prop="barter_img" label="换回图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="换回名称" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="换回货号" align="center">
            </el-table-column>
            <el-table-column prop="co_val" label="换回颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="换回尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="换回代采价" align="center">
            </el-table-column>
            <el-table-column prop="subtotal" label="小计" align="center">
            </el-table-column>
            <el-table-column
              prop="process_type_str"
              label="状态"
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">查看详情</el-button>
                            </template>
                        </el-table-column> -->
          </el-table>
        </el-col>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="card-title">操作信息</div>
        <el-table :data="logs" border style="width: 100%" height="400">
          <el-table-column prop="operator_name" label="操作人" align="center">
          </el-table-column>
          <el-table-column prop="type_str" label="操作方式" align="center">
          </el-table-column>
          <el-table-column prop="result" label="结果" align="center">
          </el-table-column>
          <el-table-column prop="create_time" label="操作时间" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      info: null,
      logs: null,
      steps_label: null,
      textarea: "",
    };
  },
  methods: {
    fetchData() {
      let url = "/erp/returnBarter/info";
      let args = {
        receipt_id: this.$route.params.id,
      };
      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.info = res.data.data.info;
          this.logs = res.data.data.logs;
          this.steps_label = res.data.data.steps_label;
        }
      });
    },
    reject() {
      let url = "/erp/WcgOrder/rejectOrder";
      let args = {
        woid: this.$route.params.id,
      };
      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$notify({
            title: "操作成功",
            message: "已驳回该代采订单",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.viewer {
  border: 1px solid #ddd;
  overflow: scroll;
  height: 928px;
}

.btn-operation {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AfterSalesDetail.vue